export const NODE_VARIANTS = {
  primary: {
    background: '#8B5CF6',
    color: '#FFFFFF',
    borderColor: '#7C3AED',
    selectedBorderColor: '#6D28D9'
  },
  dark: {
    background: '#4A5568',
    color: '#FFFFFF',
    borderColor: '#2D3748',
    selectedBorderColor: '#1A202C'
  },
  accent: {
    background: '#2D9F93',
    color: '#FFFFFF',
    borderColor: '#258A80',
    selectedBorderColor: '#1D6E66'
  },
  muted: {
    background: '#9B7B73',
    color: '#FFFFFF',
    borderColor: '#8B6B63',
    selectedBorderColor: '#7A5A52'
  },
  default: {
    background: 'var(--background-primary)',
    color: 'var(--text-primary)',
    borderColor: 'var(--color-neutral-200)',
    selectedBorderColor: 'var(--color-primary-500)'
  }
}

export const NODE_SIZES = {
  lg: { width: 400, padding: '14px 24px', fontSize: '0.9375rem' },
  md: { width: 200, padding: '10px 18px', fontSize: '0.8125rem' },
  sm: { width: 160, padding: '8px 14px', fontSize: '0.75rem' }
}

export function getVariantStyles (variantName) {
  return NODE_VARIANTS[variantName] || NODE_VARIANTS.default
}

export function getSizeStyles (sizeName) {
  return NODE_SIZES[sizeName] || NODE_SIZES.md
}
